import { useState } from 'react';
import { SizeType } from '@goldcast/player-config/src/types/asset-types';
import TemplatesList from '../../SideBar/Templates/TemplatesList';
import { ALL_TEMPLATES_LIMIT } from '../../constants';
import Button from '@/components/atoms/Button/Button';
import Icon from '@/components/atoms/Icon';

interface ClipCustomizerTemplatesPresetSectionProps {
  label: string;
  ratio: string;
  size: SizeType;
}

export default function ClipCustomizerTemplatesPresetSection({
  label,
  ratio,
  size
}: ClipCustomizerTemplatesPresetSectionProps) {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <Button
        trackingId={`templates-preset-section-${size.toLowerCase()}`}
        variation="none"
        className="flex w-full items-center justify-between !px-0 py-3 text-left"
        onClick={() => setIsOpen(prev => !prev)}
      >
        <span className="text-sm font-medium text-black">
          {label} <span className="text-slate-500">[{ratio}]</span>
        </span>
        <Icon name={isOpen ? 'IconChevronUp' : 'IconChevronDown'} className="size-4 text-gray-500" aria-hidden={true} />
      </Button>
      {isOpen && (
        <div className="pb-3">
          <TemplatesList
            limit={ALL_TEMPLATES_LIMIT}
            size={size}
            queryParams={{ has_organization: true }}
            isInsidePopover
          />
        </div>
      )}
    </>
  );
}
